import React, { useContext } from "react";
import { Switch, Route, Redirect } from "react-router";
import {
  withPermission,
  PermissionContext,
  Roles,
} from "../../../util/PermissionProvider";
import HomePage from "../HomePage";
import Layout from "../../Layout";
import MenuManagementPage from "../MenuManagementPage";
import NewsManagementPage from "../NewsManagementPage";
import PagesManagementPage from "../PagesManagementPage";
import PeriodManagementPage from "../PeriodManagementPage";
import ProgrammesManagementPage from "../ProgrammesManagementPage";
import menu from "./menu";

export default function HKNTSection(props) {
  const { match } = props;
  const { userPermissions } = useContext(PermissionContext);
  console.log(match.url);
  return (
    userPermissions && (
      <Layout menuObj={menu}>
        <Switch>
          <Route
            path={`${match.url}/homepage`}
            component={withPermission(
              HomePage,
              [Roles.SUPERADMIN, Roles.HKNT_EDITOR, Roles.HKNT_VIEWER],
              [Roles.SUPERADMIN, Roles.HKNT_EDITOR]
            )}
          />
          <Route path={`${match.url}/menu`} component={MenuManagementPage} />
          <Route path={`${match.url}/news`} component={NewsManagementPage} />
          <Route path={`${match.url}/pages`} component={PagesManagementPage} />
          <Route
            path={`${match.url}/period`}
            component={PeriodManagementPage}
          />
          <Route
            path={`${match.url}/programmes`}
            component={ProgrammesManagementPage}
          />
          <Route render={() => <Redirect to={`${match.url}/menu`} />} />
        </Switch>
      </Layout>
    )
  );
}
